import React, { useState } from "react";
import DataTable from "react-data-table-component";
import DatatableStyles from 'component/utils/DatatableStyles'

const paginationOptions = {
    rowsPerPageText: "Show Per Page:", 
    rangeSeparatorText: "dari",
  };

const CategoryDatatables = ({data, onEditCategory, onDeleteCategory}) => {
    const [search, setSearch] = useState("");

    const formattedData = data.map((item, index) => ({
      id: index + 1,
      ...item
    }));

    const filteredData = formattedData.filter((item) =>
      [item?.name]
        .some((field) => field?.toString().toLowerCase().includes(search.toLowerCase()))
    );

    
    const columns = [
      { name: "No", selector: (row) => row.id, minWidth: "70px", maxWidth: "150px",style: { display: "flex", justifyContent: "center", alignItems: "center" }, sortable: true },
      { name: "Category ID", selector: (row) => row.category_id, sortable: true, minWidth: "100px", maxWidth: "1000px",grow:2},
      { name: "Nama Category", selector: (row) => row.name, sortable: true, minWidth: "100px", maxWidth: "1000px",grow:2},
      { 
        name: "Action", 
        minWidth: "100px", 
        maxWidth: "250px", grow:1,
        style: { display: "flex", justifyContent: "center", alignItems: "center" },
        cell: (row) => (
          <div>
              <button 
                class="btn btn-sm rounded-circle btn-warning me-2" // Tambahkan margin agar tidak berdempetan
                onClick={() => onEditCategory(row)}
              >
                <i class='bx bx-edit' style={{color:"white"}}></i>
              </button>

              <button 
                class="btn btn-sm rounded-circle btn-danger"
                onClick={() => onDeleteCategory(row)}
              >
                <i class='bx bx-trash'></i>
              </button>
            </div>
        )
      }
    ];

  return (
    <div class="col-lg-12 mb-4">
        <div class="d-flex justify-content-start align-items-center mb-2">
                <input
                type="text"
                placeholder="Search..."
                class="form-control w-100"
                style={{ maxWidth: "200px" }}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                />
        </div>

        <div class="datatable-container">
            <DataTable
            columns={columns}
            data={filteredData}
            pagination
            highlightOnHover={false}
            customStyles={DatatableStyles}
            paginationPerPage={5}
            paginationRowsPerPageOptions={[5, 10, 25]}
            paginationComponentOptions={paginationOptions}
            responsive
            />
        </div>
    </div>
  );
};

export default CategoryDatatables;
